import { render } from "./LiveLeader.vue?vue&type=template&id=9eead8a2&scoped=true"
import script from "./LiveLeader.vue?vue&type=script&lang=js"
export * from "./LiveLeader.vue?vue&type=script&lang=js"

import "./LiveLeader.vue?vue&type=style&index=0&id=9eead8a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eead8a2"]])

export default __exports__